<template>
  <div class="component order-summary">
    <div class="order-header">
      <dl class="order-details">
        <dt>{{ $t('general.label.confirmation') }}:</dt>
        <dd>{{ cart.bookingId }}</dd>
        <!-- Not sure where 'date booked' comes from. Not same as transaction dates -->
        <dt>{{ $t('general.label.date-booked') }}:</dt>
        <dd>{{ cart.dateBooked }}</dd>
      </dl>
        <router-link v-if="cart.bookingId" :to="{ name: 'ticket', params: { bookingId: cart.bookingId }}" class="print-tickets" target="_blank">{{ $t('general.label.print-tickets') }}</router-link>
    </div>

    <div class="item-list">
      <cart-item v-for="item in cart.items" :key="item.id" :item="item" :thumbnail="thumbnail" :editable="editable"/>
    </div>

    <div class="order-footer">
      <dl class="total-prices">
        <dt>{{ $t('general.label.subtotal') }}:</dt>
        <dd>{{ $formatter.currency(cart.subTotal ? cart.subTotal : 0) }}</dd>
        <dt v-if="cart.discount">{{ $t('general.label.discount') }}:</dt>
        <dd v-if="cart.discount">{{ $formatter.currency(cart.discount) }}</dd>
        <dt v-if="cart.surcharge">{{ cart.surcharge.name }}:</dt>
        <dd v-if="cart.surcharge">{{ $formatter.currency(cart.surcharge.amount) }}</dd>
        <dt>{{ $t('general.label.gst') }}:</dt>
        <dd>{{ $formatter.currency(cart.taxes ? cart.taxes : 0) }}</dd>
        <dt v-if="cart.guestFee">{{ $t('general.label.booking-fee') }}:</dt>
        <dd v-if="cart.guestFee">{{ $formatter.currency(cart.guestFee) }}</dd>
        <dt class="total-label">{{ $t('general.label.total') }}:</dt>
        <dd class="total-price">{{ $formatter.currency(cart.total ? cart.total : 0) }}</dd>
      </dl>
    </div>

    <h2>{{ $t('form.label.guest-details') }}<router-link class="edit-guest-details" :to="{name: 'checkout'}" v-if="editable">{{ $t('general.label.edit') }}</router-link></h2>

    <div class="guest-details">
      <!-- If "Require individual guest details" is on, loop .guest and show .guest-num -->
      <div v-for="(guest, index) in cart.cartGuests" :key="guest.id" class="guest" :class="{even: (index % 2)}">
        <div>
          <strong>{{guest.firstName}} {{guest.lastName}}</strong>
        </div>
        <dl>
          <dt v-if="guest.phone">{{ $t('form.label.guest.phone') }}:</dt>
          <dd v-if="guest.phone">{{guest.phone}}</dd>
          <dt v-if="guest.email">{{ $t('form.label.guest.email') }}:</dt>
          <dd v-if="guest.email">{{guest.email}}</dd>
        </dl>
      </div>
    </div>


    <h2>{{ $t('form.label.payment') }}</h2>
    <div class="payment-details">
      <div v-for="(transaction, index) in cart.cartTransactions" :key="index" class="single-payment" :class="{even: (index % 2)}">
        <dl>
          <dt>{{ $t('form.label.payment-type') }}:</dt>
          <!-- Different payment method cases go here -->
          <!-- Only show gateway for credit card transactions (2000 for charge, or 2009 for refund) -->
          <dd>{{ transaction.methodName }}<span v-if="transaction.methodId == 2000 || transaction.methodId == 2009"> ({{transaction.gatewayName}})</span></dd>
          <dt>{{ $t('form.label.date') }}:</dt>
          <dd>{{ dateFormat(transaction.transactionDate) }}</dd>
          <dt>{{ $t('general.label.amount') }}:</dt>
          <dd>{{ $formatter.currency(transaction.amount) }}</dd>
        </dl>
      </div>
    </div>

  </div>
</template>

<script>

import moment from 'moment';
import CartItem from '@/components/CartItem';

export default {
  props: {
    cart: Object,
    editable: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    dateFormat(date){
      return moment(date).format("YYYY-MM-DD HH:DD:ss");
    }
  },

  components: { CartItem }

};
</script>

<style lang="scss">
.component.order-summary {

  .order-header {
    background-color: $colorBgGray;
    border: 1px solid $colorPaleGray;
    border-bottom: none;
    padding: 10px 15px;
    line-height: 22px;

    .order-details {
      margin: 0;

      dt {
        float: left;
        margin-right: 10px;
      }
      dd {
        margin: 0;
      }
    }

    .print-tickets::before {
      @include font-awesome-pseudo($fa-var-print, light);
      margin-right: 5px;
    }
  }

  .order-footer {
    background-color: $colorBgGray;
    border: 1px solid $colorPaleGray;
    border-top: none;
    padding: 10px 15px;
    margin-bottom: 25px;

    .total-prices {
      margin: 0;
      display: grid;
      grid-template-columns: 1fr auto;
      grid-column-gap: 30px;
      text-align: right;
      line-height: 22px;
      padding-top: 15px;
      padding-bottom: 8px;

      dd {
        margin: 0;
      }

      .total-label,
      .total-price {
        @include font-h2;
      }

      /*  IE */
      @media all and (-ms-high-contrast:none) {
        @include clearfix;
        dt {
          clear: both;
          float: left;
        }
        dd {
          float: right;
        }
      }
    }
  }

  .even {
    background-color: $colorBgGray;
  }

  .guest-details,
  .payment-details {
    border: 1px solid $colorPaleGray;
    padding: 10px 15px;
    margin-bottom: 25px;
    line-height: 22px;

    .guest{
      padding: 5px;

      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }

    .single-payment{
      padding: 5px;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }


    dl {
      margin: 0;
      display: grid;
      grid-template-columns: auto 1fr;
      grid-column-gap: 15px;

      dd {
        margin: 0;
      }

      /*  IE */
      @media all and (-ms-high-contrast:none) {
        @include clearfix;
        dt {
          clear: both;
          float: left;
          margin-right: 15px;
        }
        dd {
          float: left;
        }
      }
    }
  }

  .edit-guest-details {
    @include font-default;
    margin-left: 10px;
  }


}
</style>